export const ContextKeyLabel = {
  Readonly: Symbol('readonly'),
  ProviderDetail: Symbol('provider-detail'),
};
